import { MaskedLines, Eyebrow } from "@/components/Motion";
import { motion } from "framer-motion";

export const PageHero = ({ eyebrow, lines, sub, children }) => (
  <section className="relative overflow-hidden bg-gradient-to-br from-[#1D4ED8] via-[#2563EB] to-[#4F46E5] text-white">
    <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-white/10 blur-3xl pointer-events-none" />
    <div className="absolute -bottom-32 left-1/4 h-80 w-80 rounded-full bg-indigo-400/20 blur-3xl pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-24 md:pt-24 md:pb-32">
      <Eyebrow light>{eyebrow}</Eyebrow>
      <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-4xl">
        <MaskedLines lines={lines} />
      </h1>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.5 }}
          className="mt-6 text-base md:text-lg leading-relaxed max-w-2xl text-white/80"
        >
          {sub}
        </motion.p>
      )}
      {children}
    </div>
    <svg className="absolute bottom-0 left-0 w-full h-8 md:h-12 text-white" viewBox="0 0 1440 60" fill="currentColor" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,32 C360,72 1080,-8 1440,32 L1440,60 L0,60 Z" />
    </svg>
  </section>
);
